import { createRouter, createWebHistory } from "vue-router";
import { inject } from 'vue';
import { storeToRefs } from 'pinia'
import HomeIndex from "../components/sites/HomeIndex.vue";
import WebinareIndex from "../components/sites/WebinareIndex.vue";
import LoginIndex from "../components/sites/LoginIndex.vue";
import AdminToolIndex from "../components/sites/AdminToolIndex.vue";
import WatchIndex from "../components/sites/WatchIndex.vue";
import TeacherIndex from "../components/objects/webinar/TeacherIndex.vue";
import AudienceIndex from "../components/objects/webinar/AudienceIndex.vue";
import AdminIndex from "../components/objects/webinar/AdminIndex.vue";
import SuperAdmin from "../components/objects/webinar/SuperAdmin.vue";
import ZertifikatIndex from "../components/sites/ZertifikatIndex.vue";


const routes = [
  {
    path: "/",
    name: "home",
    component: HomeIndex,
  },
  {
    path: "/webinare",
    name: "webinare",
    component: WebinareIndex,
  },
  {
    path: "/watch/:teilnahmeid/:hash/:browserToken?",
    name: "webinar",
    component: AudienceIndex,
  },
  {
    path: "/admin/:teilnahmeid/:terminid/:hash",
    name: "admin",
    component: AdminIndex,
  },

  {
    path: "/dozent/:teilnahmeid/:hash/:debug?",
    name: "dozent",
    component: TeacherIndex,
  },
  {
    path: "/super/:wter_id/:wteil_id",
    name: "super-admin",
    component: SuperAdmin,
  },
  {
    path: "/zertifikat/:teilnahmeid/:hash",
    name: "zertifikat",
    component: ZertifikatIndex,
  },
  {
    path: "/test",
    name: "test",
    component: WatchIndex,
  },
  {
    path: "/login",
    name: "login",
    component: LoginIndex,
  },
  {
    path: "/admin-tools/:webi_id?/:termin_id?",
    name: "admin-tools",
    component: AdminToolIndex,
    meta: {
      requiresAuth: true,
      requiresAdmin: true,
    },
  },


  // {
  //   // GESCHÜTZTE ROUTE: Benutzerprofil
  //   path: '/profile',
  //   name: 'Profile',
  //   component: Profile,
  //   meta: {
  //     requiresAuth: true
  //   }
  // }
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  // Verwende inject, um den userStore zu erhalten
  const userStore = inject('userStore');
  
  if (!userStore) {
    console.error('userStore is not available');
    next();
    return;
  }

  const { userData } = storeToRefs(userStore);

  // Beispiel: Überprüfe, ob der Benutzer eingeloggt ist
  if (to.meta.requiresAuth && !userData.value) {
    console.log('Benutzer ist nicht eingeloggt');
    next({ path: "/login" }); // Leite zur Login-Seite um
  } else if (to.meta.requiresAdmin && Number(userData.value?.user_is_admin) !== 1) {
    next({ path: "/" });
  } else {
    next(); // Erlaube die Navigation
  }
});
export default router;
